<div class="frd-overlay" (click)="close()">
  <div class="frd-dialog mat-elevation-z8" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="frd-header">
      <div class="frd-header-content">
        <mat-icon class="frd-icon">forward</mat-icon>
        <div>
          <h3 class="frd-title">Forward Requisition</h3>
          <span class="frd-subtitle" *ngIf="selectedRequisition?.data?.RequisitionData?.enquiryId">
            {{ selectedRequisition.data.RequisitionData.enquiryId }}
            <ng-container *ngIf="selectedRequisition.data.RequisitionData.docNo">
              &middot; {{ selectedRequisition.data.RequisitionData.docNo }}
            </ng-container>
          </span>
        </div>
      </div>
      <button mat-icon-button (click)="close()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-divider></mat-divider>

    <div class="frd-body">
      <form class="frd-form">

        <!-- Forwarding For (activity / type) -->
        <mat-form-field appearance="outline" class="frd-field">
          <mat-label>Forwarding For</mat-label>
          <mat-icon matPrefix>route</mat-icon>
          <mat-select [(ngModel)]="selectedActivity" name="activity" (ngModelChange)="onActivityChange($event)"
            required>
            @for (a of activities; track a.code) {
            <mat-option [value]="a.code">{{ a.name }}</mat-option>
            }
          </mat-select>
          <mat-error *ngIf="!selectedActivity">Forwarding type is required</mat-error>
        </mat-form-field>

        <!-- Team -->
        <mat-form-field appearance="outline" class="frd-field">
          <mat-label>Team</mat-label>
          <mat-icon matPrefix>group</mat-icon>
          <mat-select [(ngModel)]="selectedTeam" name="team" (ngModelChange)="onTeamChange($event)" required>
            <mat-option *ngIf="!selectedActivity" disabled>
              Select a forwarding type first
            </mat-option>
            @for (t of teams; track t.team) {
            <mat-option [value]="t.team">{{ t.team }}</mat-option>
            }
          </mat-select>
          <mat-error *ngIf="!selectedTeam">Team is required</mat-error>
        </mat-form-field>

        <!-- User -->
        <mat-form-field appearance="outline" class="frd-field">
          <mat-label>User</mat-label>
          <mat-icon matPrefix>person</mat-icon>
          <mat-select [(ngModel)]="selectedUser" name="user" required>
            <mat-option *ngIf="!selectedTeam" disabled>
              Select a team first
            </mat-option>
            @for (u of users; track u.id) {
            <mat-option [value]="u.name">{{ u.name }}</mat-option>
            }
          </mat-select>
          <mat-error *ngIf="!selectedUser">User is required</mat-error>
        </mat-form-field>

        <!-- Remarks -->
        <mat-form-field appearance="outline" class="frd-field">
          <mat-label>Remarks</mat-label>
          <mat-icon matPrefix>notes</mat-icon>
          <textarea matInput [(ngModel)]="remarks" name="remarks" rows="3"
            placeholder="Context or notes for the assignee" required></textarea>
          <mat-error *ngIf="!remarks?.trim()">Remarks are required</mat-error>
        </mat-form-field>

      </form>
    </div>

    <mat-divider></mat-divider>

    <div class="frd-actions">
      <button mat-button type="button" (click)="close()">Cancel</button>
      <button mat-raised-button color="primary" type="button" (click)="send()"
        [disabled]="isSubmitting || !isFormValid">
        <mat-spinner *ngIf="isSubmitting" diameter="18" class="btn-spinner"></mat-spinner>
        <mat-icon *ngIf="!isSubmitting">forward</mat-icon>
        {{ isSubmitting ? 'Forwarding…' : 'Forward' }}
      </button>
    </div>

  </div>
</div>